import { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useProviderDisclaimer, { useRelations } from '@hooks/useProviderDisclaimer'

import PageContext from '@contexts/pageContext'

const confirmDelete = (deleteProviderDisclaimer, deleteFn) => {
  const deleteProviderDisclaimerPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Disclaimer Deleted',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, delete it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Delete Disclaimer?',
  }).then(({ value }) => {
    if (value){
      deleteProviderDisclaimer(deleteProviderDisclaimerPayload)
    }
  })
}

const DisclaimerListItem = (props) => {
  const { providerDisclaimer } = props
  const { acceptance_required } = providerDisclaimer

  const pageContext = useContext(PageContext)
  const { callbacks: { deleteProviderDisclaimer } } = pageContext

  const { serviceProduct } = useRelations(providerDisclaimer)

  const {
    callbacks: {
      createOrEditProviderDisclaimer,
      deleteProviderDisclaimer: deleteFn,
    },
  } = useProviderDisclaimer(providerDisclaimer)

  return (
    <DashboardModuleListItem
      secondaryText={acceptance_required ? 'Acceptance Required' : 'Acceptance Not Required'}
      title={serviceProduct.title}
    >
      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditProviderDisclaimer()}
          type="edit"
        />

        <DashboardModuleListItem.Icon onClick={() => confirmDelete(deleteProviderDisclaimer, deleteFn)} type="delete" />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

DisclaimerListItem.propTypes = {
  providerDisclaimer: PropTypes.object.isRequired,
}

export default DisclaimerListItem
